export const FE_BASE_URL_HOST = "https://udacitypartner.com";
